import featureTesting from './FeatureTesting';

export function hasAppearance() {
  return featureTesting.getTestResult('appearance');
}

export function hasTouch() {
  return featureTesting.getTestResult('touchevents');
}
